export enum CreateYourOwnActionTypes {
    API_RESPONSE_SUCCESS = '@@createYourOwn/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@createYourOwn/API_RESPONSE_ERROR',
    CREATE_YOUR_OWN_LIST = '@@createYourOwn/CREATE_YOUR_OWN_LIST',
}